import { defineMessages } from 'react-intl';

export default defineMessages({
  headTitle: {
    id: 'signup.head.title',
    defaultMessage: 'Sign up',
  },
  contextualHeadTitle: {
    id: 'signup.contextual.head.title',
    defaultMessage: 'Sign up to continue to',
    description: `Precedes a page title or issue number. For example, "Sign up to continue to Sarah's Blogpost"`,
  },
  socialAuthOr: {
    id: 'social.auth.or',
    defaultMessage: 'or',
  },
  socialAuthOrContinueWith: {
    id: 'social.auth.or-continue-with',
    defaultMessage: 'Or continue with:',
  },
  headerTitle: {
    id: 'signup.header.title',
    defaultMessage: 'Sign up to continue',
    description:
      'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"',
  },
  startCollaboratingHeaderTitle: {
    id: 'signup.header.start.collaborating.title',
    defaultMessage: 'Sign up to start collaborating',
    description:
      'Shown before the signup form. e.g. "Sign up first then we will show you the content you requested"',
  },
});
